import intl from 'react-intl-universal';
import SingleChipDisplay from './DiagnosticResult/SingleChipDisplay';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import logger from 'utils/logger';

const log = logger.createLogger('KenshinTablColumns');

export const getKenshinTableColumns = (
  isHiding,
  doctorsFilterOptions,
  diagnosticResultFilterSelectOptions,
  setViewportWebUrls,
  setViewModalOpen
) => {
  return [
    {
      header: intl.get('kenshin_case_table_header_display_index'),
      accessorKey: 'displayIndex',
      size: 50,
      enableColumnActions: false,
      enableColumnFilter: true,
      filterVariant: 'range',
      filterFn: 'between',
      enableColumnFilterModes: false,
      muiFilterTextFieldProps: {
        type: 'number',
      },
    },
    {
      header: intl.get('kenshin_case_table_header_patient_id'),
      accessorKey: 'patientId',
      enableColumnActions: false,
      enableColumnFilter: true,
      enableColumnFilterModes: false,
    },
    {
      header: intl.get('kenshin_case_table_header_study_id'),
      accessorKey: 'studyInstanceUID',
      enableColumnActions: false,
      enableColumnFilter: true,
      enableColumnFilterModes: false,
    },
    {
      header: intl.get('kenshin_case_table_header_body_part'),
      accessorKey: 'bodypart',
      enableColumnActions: false,
      enableColumnFilter: true,
      enableColumnFilterModes: false,
    },
    {
      header: intl.get('kenshin_case_table_header_modality'),
      accessorKey: 'modality',
      enableColumnActions: false,
      enableColumnFilter: true,
      enableColumnFilterModes: false,
    },
    {
      header: intl.get('kenshin_case_table_header_doctor_in_charge'),
      accessorKey: 'doctorId',
      enableColumnFilterModes: false,
      enableColumnActions: false,
      enableColumnFilter: isHiding ? false : true,
      filterVariant: 'select',
      filterSelectOptions: doctorsFilterOptions,
      Cell: ({ renderedCellValue }) =>
        doctorCell(renderedCellValue, doctorsFilterOptions, isHiding),
    },
    {
      header: intl.get('kenshin_case_table_header_diagnostic_result'), // （未診断、不明、異常あり、異常なし）
      accessorKey: 'diagnosis',
      enableColumnActions: false,
      enableColumnFilter: isHiding ? false : true,
      filterVariant: 'select',
      enableColumnFilterModes: false,
      filterSelectOptions: diagnosticResultFilterSelectOptions,
      filterFn: (row, id, filterValue) => {
        return row.getValue(id) === filterValue;
      },
      Cell: ({ renderedCellValue, row }) =>
        diagnosticResultCell(renderedCellValue, row, isHiding),
    },
    {
      header: intl.get('kenshin_case_table_header_viewer'),
      accessorKey: 'webUrl',
      size: 50,
      enableSorting: false,
      enableColumnActions: false,
      enableColumnFilter: false,
      enableColumnFilterModes: false,
      Cell: ({ renderedCellValue }) =>
        webUrlCell(renderedCellValue, setViewportWebUrls, setViewModalOpen),
    },
  ];
};

const doctorCell = (renderedCellValue, doctorsFilterOptions, isHiding) => {
  const doctorId = renderedCellValue;
  const doctorOption = doctorsFilterOptions.find((d) => d.value === doctorId);
  if (isHiding) {
    return intl.get('kenshin_issue_details_case_status_in_progress');
  } else {
    return doctorOption.label;
  }
};

doctorCell.propTypes = {
  renderedCellValue: PropTypes.string.isRequired,
  doctorsFilterOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
};

const diagnosticResultCell = (renderedCellValue, row, isHiding) => {
  if (isHiding) {
    return intl.get('kenshin_issue_details_case_status_in_progress');
  } else {
    return (
      <SingleChipDisplay
        key={renderedCellValue}
        result={renderedCellValue}
        row={row.original.index}
      />
    );
  }
};

diagnosticResultCell.propTypes = {
  renderedCellValue: PropTypes.string.isRequired,
  isHiding: PropTypes.bool.isRequired,
};

const webUrlCell = (
  renderedCellValue,
  setViewportWebUrls,
  setViewModalOpen
) => {
  const webUrl = renderedCellValue;
  return (
    <Button
      variant="contained"
      color="primary"
      style={{ color: 'white' }} // make the text color to be white; refine code;
      onClick={async () => {
        setViewportWebUrls(webUrl);
        setViewModalOpen(true);
      }}>
      {intl.get('case_list_button_view')}
    </Button>
  );
};

webUrlCell.propTypes = {
  renderedCellValue: PropTypes.string.isRequired,
  setViewportWebUrls: PropTypes.func.isRequired,
  setViewModalOpen: PropTypes.func.isRequired,
};
